import React, { useEffect } from 'react';
import { ISession } from '../../../models/pro-sites';
import {
    IOrderDetails,
    IProductDetail,
    IProductHoverImage,
} from '../../../models/product-detail';
import { CartItemTypes, MIRACLEEAR } from '../../common/constants';
interface IImageSection {
    productDetailState: IProductDetail;
    productHoverImage: IProductHoverImage | undefined;
    orderState: IOrderDetails;
    session: ISession;
    top: boolean;
}
export const ImageSection = ({
    productDetailState,
    productHoverImage,
    orderState,
    session,
    top,
}: IImageSection) => {
    return (
        <div className="row">
            {session.selectedBrand === MIRACLEEAR && top ? (
                <img
                    style={{
                        height: '320px',
                        marginTop: '-30px',
                        zIndex: 0,
                    }}
                    src={productDetailState!.imageUrl}
                    alt="Unavailable"
                />
            ) : (
                <img
                    style={{
                        height: '320px',
                        marginTop: '-30px',
                        zIndex: 0,
                    }}
                    src={
                        productHoverImage && productHoverImage.imageUrl
                            ? productHoverImage.imageUrl
                            : [
                                  CartItemTypes.Earmold,
                                  CartItemTypes.SoundGearEarmold,
                              ].includes(productDetailState!.cartItemTypeId!) &&
                              orderState!.earmoldDesignId
                            ? `/services/catalogs/${session!.catalog}/designs/${
                                  orderState!.earmoldDesignId ||
                                  productDetailState!.earmolds.find(
                                      (x) =>
                                          x.key ===
                                          productDetailState!.earmoldCategory
                                  )!.items[0].designId
                              }/image`
                            : productDetailState!.imageUrl
                    }
                    alt="Unavailable"
                />
            )}
        </div>
    );
};
